import { pipe } from 'fp-ts/lib/function';
import { failure, parse, string, success } from 'io-ts/lib/Decoder';

const reEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const Email = pipe(
	string,
	parse((s) =>
		s.trim().length > 0 &&
		// check if s is a valid email
		reEmail.test(s)
			? success(s)
			: failure(s, 'valid email')
	)
);
